<div class="page">
  <div *ngIf="showHeader"  class="d-flex justify-content-between mb-4 w-100 align-items-start">
    <div class="d-flex flex-column">
      <h1 class="d-flex my-1">
        <div class="bg-white placeholder-content-item" style="width: 300px; height: 28px;"></div>
      </h1>
      <ul class="breadcrumb breadcrumb-dot fw-semibold text-gray-600 fs-7 my-1 align-items-center">
        <li class="breadcrumb-item text-gray-600">
          <div class="bg-white placeholder-content-item me-2" style="width: 100px; height: 20px;"></div>
        </li>
        <li class="breadcrumb-item fs-8 text-gray-600">
          <div class="bg-white placeholder-content-item me-2" style="width: 100px; height: 20px;"></div>
        </li>
        <li class="breadcrumb-item fs-8 text-gray-500">
          <div class="bg-white placeholder-content-item me-2" style="width: 100px; height: 20px;"></div>
        </li>
      </ul>
    </div>
    <div class="d-flex align-items-center pb-2 py-md-1 flex-wrap">
      <app-back-button></app-back-button>
    </div>
  </div>
  <div *ngIf="showMenu" class="card av-nav w-100">
    <div class="card-body py-0">
      <ul class="nav py-0">
        <li class="nav-item">
          <div class="bg-white placeholder-content-item me-2 rounded-1" style="width: 150px; height: 45px"></div>
        </li>
        <li class="nav-item">
          <div class="bg-white placeholder-content-item me-2 rounded-1" style="width: 150px; height: 45px"></div>
        </li>
        <li class="nav-item">
          <div class="bg-white placeholder-content-item me-2 rounded-1" style="width: 150px; height: 45px"></div>
        </li>
      </ul>
    </div>
  </div>
  <div class="card w-100 mb-5">
    <div class="row">
      <div class="col-md-8">
        <div class="card-title m-0">
          <h3 class="fw-bold m-0 p-4">
            <div class="bg-white placeholder-content-item" style="width: 300px; height: 25px;"></div>
          </h3>
        </div>
        <div class="card-body border-top p-4">
          <div class="row mb-1 d-flex align-items-center">
            <label class="col-lg-4">
              <div class="bg-white placeholder-content-item" style="width: 150px; height: 25px;"></div>
            </label>
            <div class="col-lg-8">
              <div class="bg-white placeholder-content-item rounded-1 w-100" style="height: 40px;"></div>
            </div>
          </div>
          <div class="row mb-1 d-flex align-items-center">
            <label class="col-lg-4">
              <div class="bg-white placeholder-content-item" style="width: 150px; height: 25px;"></div>
            </label>
            <div class="col-lg-8">
              <div class="bg-white placeholder-content-item rounded-1 w-100" style="height: 40px;"></div>
            </div>
          </div>
          <div class="row mb-1 d-flex align-items-center">
            <label class="col-lg-4">
              <div class="bg-white placeholder-content-item" style="width: 150px; height: 25px;"></div>
            </label>
            <div class="col-lg-8">
              <div class="bg-white placeholder-content-item rounded-1 w-100" style="height: 40px;"></div>
            </div>
          </div>
          <div class="row mb-1 d-flex align-items-center">
            <label class="col-lg-4">
              <div class="bg-white placeholder-content-item" style="width: 150px; height: 25px;"></div>
            </label>
            <div class="col-lg-8">
              <div class="bg-white placeholder-content-item rounded-1 w-100" style="height: 40px;"></div>
            </div>
          </div>
          <div class="row mb-1 d-flex align-items-center">
            <label class="col-lg-4">
              <div class="bg-white placeholder-content-item" style="width: 150px; height: 25px;"></div>
            </label>
            <div class="col-lg-8">
              <div class="bg-white placeholder-content-item rounded-1 w-100" style="height: 40px;"></div>
            </div>
          </div>
          <div class="row mb-1 d-flex align-items-center">
            <label class="col-lg-4">
              <div class="bg-white placeholder-content-item" style="width: 150px; height: 25px;"></div>
            </label>
            <div class="col-lg-8">
              <div class="bg-white placeholder-content-item rounded-1 w-100" style="height: 40px;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 border-start">
        <div class="card-title m-0">
          <h3 class="fw-bold m-0 p-4">
            <div class="bg-white placeholder-content-item" style="width: 100px; height: 25px;"></div>
          </h3>
        </div>
        <div class="card-body border-top p-4">
          <div class="row mb-3 d-flex justify-content-between align-items-center">
            <label class="col-xxl-4 text-gray-600 fw-semibold fs-8">
              <div class="bg-white mb-2 placeholder-content-item" style="width: 100px; height: 20px;"></div>
            </label>
            <div class="col-xxl-8 d-flex justify-content-between align-items-center">
              <div class="bg-white placeholder-content-item" style="width: 100px; height: 20px;"></div>
              <div class="bg-white placeholder-content-item" style="width: 50px; height: 20px;"></div>
            </div>
          </div>
          <div class="row mb-3 d-flex justify-content-between align-items-center">
            <label class="col-xxl-4 text-gray-600 fw-semibold fs-8">
              <div class="bg-white mb-2 placeholder-content-item" style="width: 100px; height: 20px;"></div>
            </label>
            <div class="col-xxl-8 d-flex justify-content-between align-items-center">
              <div class="bg-white placeholder-content-item" style="width: 150px; height: 20px;"></div>
            </div>
          </div>
          <div class="row mb-3 d-flex justify-content-between align-items-center">
            <label class="col-xxl-4 text-gray-600 fw-semibold fs-8">
              <div class="bg-white mb-2 placeholder-content-item" style="width: 100px; height: 20px;"></div>
            </label>
            <div class="col-xxl-8 d-flex justify-content-between align-items-center">
              <div class="bg-white placeholder-content-item" style="width: 150px; height: 20px;"></div>
            </div>
          </div>
          <hr />
          <div class="d-flex align-items-center pb-2 py-md-1 flex-wrap">
            <div class="bg-white placeholder-content-item me-2" style="width: 100px; height: 45px;"></div>
            <div class="bg-white placeholder-content-item" style="width: 100px; height: 45px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
